import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useStickyAlert } from "./useStickyAlert";
import type { StickyAlertConfig } from "./useStickyAlert";

export interface StickyAlertProps {
  /** Seed config for stories and tests. In production omit this — the component reads from Statsig. */
  defaultConfig?: StickyAlertConfig;
}

const FullWidthAlert = styled(Alert)({
  borderRadius: 0,
});

/** Full-width banner alert driven by the `platform_alert` Statsig dynamic config. Renders nothing when no alert is active. */
export function StickyAlert({ defaultConfig }: StickyAlertProps = {}) {
  const { t } = useTranslation();
  const { alert, dismiss } = useStickyAlert(defaultConfig);

  if (!alert) return null;

  return (
    <FullWidthAlert
      severity={alert.severity}
      onClose={alert.dismissable !== "NO" ? dismiss : undefined}
      closeText={t("alert.dismiss")}
    >
      <AlertTitle>{alert.title}</AlertTitle>
      <Typography variant="body2">{alert.description}</Typography>
    </FullWidthAlert>
  );
}
